var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMyProfileCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 46,
    viewBox: "0 0 25 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 28.5215,
    r: 10,
    fill: "#EC3232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6036 33.6172L12.3936 30.1492L10.2686 33.6172H8.65362L11.6626 28.9932L8.65362 24.3012H10.4046L12.6146 27.7522L14.7226 24.3012H16.3376L13.3456 28.9082L16.3546 33.6172H14.6036Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMyProfileCloseIcon);
export default __webpack_public_path__ + "static/media/manage_my_profile_close_icon.e44ce29812a0a561fffa4102f22d89a6.svg";
export { ForwardRef as ReactComponent };